import createRequest from "@/utils/request"
import { exportFileAcc } from "@/utils"
import responseInterceptors from "@/utils/request/interceptors/response/browser"
/**
 * 隐私政策-列表
 */
const getPolicyList = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/list", payload)

/**
 * 隐私政策-详情
 */
const getPolicyInfo = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/info", {
        params: payload
    })
/**
 * 隐私政策-获取最新版本
 */
const getPolicyLastVersion = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/last-version", {
        params: payload
    })
/**
 * 隐私政策-更新
 */
const updatePolicy = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/update", payload)
/**
 * 隐私政策-获取上一个版本
 */
const getPreviousPolicy = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/previous-version", {
        params: payload
    })
/**
 * 隐私政策-操作记录
 */
const getOperateRecord = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/operate-record", {
        params: payload
    })
/**
 * 隐私政策-历史记录
 */
const getHistoryVersions = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/history-versions", {
        params: payload
    })
/**
 * 产品与隐私政策相关对照-创建
 */
const createComparePolicy = (payload: any) =>
    createRequest("SDL_URL").post("/products/privacy-policy/create", payload)
/**
 * 产品与隐私政策相关对照-详情
 */
const getComparePolicy = (payload: any) =>
    createRequest("SDL_URL").get("/products/privacy-policy/info", {
        params: payload
    })
/**
 * 产品与隐私政策相关对照-列表
 */
const getComparePolicyList = (payload: any) =>
    createRequest("SDL_URL").post("/products/privacy-policy/list", payload)
/**
 * 产品与隐私政策相关对照-更新
 */
const updateComparePolicy = (payload: any) =>
    createRequest("SDL_URL").post("/products/privacy-policy/update", payload)
/**
 * 产品与隐私政策相关对照-操作记录
 */
const getComparePolicyRecord = (payload: any) =>
    createRequest("SDL_URL").get("/products/privacy-policy/operate-record", { params: payload })
/**
 * 产品与隐私政策相关对照--导出
 * @param payload
 */
const exportComparePolicy = (payload: any) => {
    const axios = createRequest("SDL_URL", true, { responseType: "blob" })
    axios.interceptors.response.use((res: any) => res, responseInterceptors[1])
    return axios.post("/products/privacy-policy/export", payload).then(exportFileAcc)
}
/**
 * 隐私政策导出
 * @param payload
 */
const exportPolicy = (payload: any) => {
    const axios = createRequest("SDL_URL", true, { responseType: "blob" })
    axios.interceptors.response.use((res: any) => res, responseInterceptors[1])
    return axios.post("/privacy-policy/export", payload).then(exportFileAcc)
}
/**
 * 隐私政策-部署
 */
const deployPolicy = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/deploy", payload)
/**
 * 隐私政策-预览
 */
const privacyPolicyPreview = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/preview", payload)
/**
 * 隐私政策-历史版本
 */
const getPolicyOldVersion = (payload: any) =>
    createRequest("SDL_URL").get("/openapi/privacy-policy/old-version", { params: payload })
/**
 * 文本类型列表-审批中心
 */
const getTextTypeList = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/text-type/list", { params: payload })

/**
 * 文本类型启用/禁用
 */
const textTypeEnableOrDisable = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/text-type/enable-or-disable", payload)
/**
 * 文本类型更新
 */
const textTypeUpdate = (payload: any) =>
    createRequest("SDL_URL").post("/privacy-policy/text-type/update", payload)
/**
 * 文本类型创建
 */
const textTypeCreate = (payload: any) =>
    createRequest("SDL_URL").post<number[]>("/privacy-policy/text-type/create", payload)

/**
 * 获取链接选项列表（分页）
 */
const getLinkOptions = (payload: any) =>
    createRequest("SDL_URL").get("/privacy-policy/link-options", {
        params: payload
    })
export default {
    getPolicyList,
    getPolicyInfo,
    getPolicyLastVersion,
    updatePolicy,
    getPreviousPolicy,
    getOperateRecord,
    getHistoryVersions,
    createComparePolicy,
    getComparePolicy,
    getComparePolicyList,
    updateComparePolicy,
    getComparePolicyRecord,
    exportComparePolicy,
    exportPolicy,
    deployPolicy,
    getPolicyOldVersion,
    privacyPolicyPreview,
    getTextTypeList,
    textTypeEnableOrDisable,
    textTypeUpdate,
    textTypeCreate,
    getLinkOptions
}
